module.exports = __webpack_public_path__ + "static/media/Plesetskaya.72218464.wav";